/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailabilityRetrievalResult } from '../../models/availability-retrieval-result';

export interface CatalogEntriesAvailabilityGet$Params {
  storeId: string;
  catalogEntryId: string;
  contextCatalogEntryId?: string;
  'Active-Tenant-Identifier': string;
}

export function catalogEntriesAvailabilityGet(http: HttpClient, rootUrl: string, params: CatalogEntriesAvailabilityGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailabilityRetrievalResult>> {
  const rb = new RequestBuilder(rootUrl, catalogEntriesAvailabilityGet.PATH, 'get');
  if (params) {
    rb.query('storeId', params.storeId, {});
    rb.query('catalogEntryId', params.catalogEntryId, {});
    rb.query('contextCatalogEntryId', params.contextCatalogEntryId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AvailabilityRetrievalResult>;
    })
  );
}

catalogEntriesAvailabilityGet.PATH = '/catalog-entries/availability';
